<template>
  <v-dialog v-model="show" max-width="600">
    <v-card>
      <v-card-title class="body-1">
        {{ userData.ID > 0 ? 'Edit user' : 'Add user' }}
        <v-spacer></v-spacer>
        <v-btn icon small @click="show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form v-model="formValid">
          <v-container>
            <v-row class="d-flex align-center">
              <v-col v-if="isGlobalAdmin" cols="12">
                <v-text-field
                  v-model="clientId"
                  label="Client Id"
                  hide-details
                  outlined
                  type="number"
                  :disabled="userData.Status === 'APPROVED'"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="userData.Name"
                  :label="$vuetify.lang.t('$vuetify.EDIT_FLEETS.USER_NAME')"
                  hide-details
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="userData.Email"
                  :label="$vuetify.lang.t('$vuetify.EDIT_FLEETS.EMAIL')"
                  hide-details
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0">
                <!-- <v-text-field
                  v-model="userData.PhoneNumber"
                  :label="$vuetify.lang.t('$vuetify.EDIT_FLEETS.PHONE_NUMBER')"
                  hide-details
                  outlined
                  required
                  :disabled="userData.Status === 'APPROVED'"
                ></v-text-field> -->
                <phone-select
                  :initial-country-code="
                    userData.Region && userData.Region !== ''
                      ? userData.Region
                      : fleet.Region
                  "
                  :initial-phone-number="userData.PhoneNumber"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="userData.CarNumber"
                  :value="userData.CarNumber"
                  :label="$vuetify.lang.t('$vuetify.EDIT_FLEETS.CAR_NUMBER')"
                  hide-details
                  outlined
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model.number="dailyLimit"
                  :label="$vuetify.lang.t('$vuetify.EDIT_FLEETS.DAILY_LIMIT')"
                  hide-details
                  outlined
                  type="number"
                  :suffix="fleet.Currency"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model.number="monthlyLimit"
                  :label="$vuetify.lang.t('$vuetify.EDIT_FLEETS.MONTHLY_LIMIT')"
                  hide-details
                  outlined
                  type="number"
                  :suffix="fleet.Currency"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="userData.Comment"
                  :label="$vuetify.lang.t('$vuetify.COMMENTS')"
                  hide-details
                  outlined
                >
                </v-textarea>
              </v-col>
              <v-col
                v-if="(userData.ID || userData.ID > 0) && isGlobalAdmin"
                cols="12"
              >
                Reg. type:
                <span class="font-weight-bold">
                  {{ userData.RegistrationType }}
                </span>
                <br />
                Status:
                <span class="font-weight-bold">
                  {{ userData.Status }}
                </span>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :disabled="!formValid"
          @click="updateFleetUser()"
        >
          {{ $vuetify.lang.t('$vuetify.SAVE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import FleetUser from '@/models/fleet-user'
import { EventBus } from '@/event-bus.js'

export default {
  name: 'EditFleetUserDialog',
  components: {
    PhoneSelect: () =>
      import(
        /* webpackChunkName: "PhoneSelect" */ '@/components/commonComponents/PhoneSelect'
      )
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    selectedUser: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: 'Add user'
    }
  },
  data() {
    return {
      formValid: true,
      validFromPicker: false,
      validToPicker: false,
      userData: { ...this.selectedUser },
      privileges: [
        { id: 1, title: 'Superadmin' },
        { id: 2, title: 'Region/Zone admin' },
        { id: 3, title: 'None' }
      ],
      selectedPrivileges: null,
      confirmPassword: '',
      vehicles: '',
      diallingCode: '',
      isValidPhoneNumber: false
    }
  },
  computed: {
    ...mapGetters('app', ['loading', 'error', 'availableApplications']),
    ...mapGetters('authentication', ['user', 'isGlobalAdmin']),
    ...mapGetters('users', ['userRegions', 'userZones']),
    ...mapGetters('fleets', ['fleet']),
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.userData = new FleetUser().getObject()
          this.$emit('close')
        }
      }
    },
    clientId: {
      get() {
        return Number(this.userData.ClientId)
      },
      set(val) {
        this.userData.ClientId = Number(val)
      }
    },
    dailyLimit: {
      get() {
        return this.userData.DailyLimitInCents / 100
      },
      set(val) {
        this.userData.DailyLimitInCents = val * 100
      }
    },
    monthlyLimit: {
      get() {
        return this.userData.MonthlyLimitInCents / 100
      },
      set(val) {
        this.userData.MonthlyLimitInCents = val * 100
      }
    }
  },
  created() {
    EventBus.$on('phoneNumberChanged', item => {
      this.userData.PhoneNumber = item.event
      this.isValidPhoneNumber = item.valid
    })
    EventBus.$on('phoneDiallingCodeChanged', item => {
      this.diallingCode = item.event.dialling_code
      this.isValidPhoneNumber = item.valid
    })

    if (!this.userData.DailyLimitInCents) {
      this.userData.DailyLimitInCents = this.fleet.DailyLimitInCentsPerUser
    }
    if (!this.userData.MonthlyLimitInCents) {
      this.userData.MonthlyLimitInCents = this.fleet.MonthlyLimitInCentsPerUser
    }
  },
  methods: {
    ...mapActions('fleets', ['postFleetUser']),
    updateFleetUser() {
      if (!this.user.isAdmin) {
        if (this.userData.RegistrationType === 'MANUALLY_INVITED') {
          if (
            (!this.userData.PhoneNumber ||
              this.userData.PhoneNumber.trim().length === 0) &&
            (!this.userData.Email || this.userData.Email.trim().length === 0)
          ) {
            return this.errorAlert('Phone number or Email is required')
          }
        } else {
          // eslint-disable-next-line no-lonely-if
          if (
            (!this.userData.PhoneNumber ||
              this.userData.PhoneNumber.trim().length === 0) &&
            (!this.userData.Name || this.userData.Name.trim().length === 0)
          ) {
            return this.errorAlert('Phone number or Name is required')
          }
        }
      }
      if (this.userData.PhoneNumber && !this.isValidPhoneNumber) {
        return this.errorAlert('Invalid Phone number')
      }
      this.userData.PhoneNumber =
        this.diallingCode.replace('+', '') + this.userData.PhoneNumber
      return this.postFleetUser(this.userData).then(() => {
        if (!this.error) {
          this.show = false
        }
      })
    },
    errorAlert(message) {
      this.$store.commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'error',
          message
        },
        { root: true }
      )
    }
  }
}
</script>
